import React, { Component } from "react";

class ChatWidget extends Component {
  componentDidMount() {
    var Tawk_API = Tawk_API || {};
    var Tawk_LoadStart = new Date();
    (function() {
      var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
      s1.async = true;
      s1.src = "https://embed.tawk.to/682319d2bddad9190c4b88b0/1ir4hpohc";
      s1.charset = "UTF-8";
      s1.setAttribute("crossorigin", "*");
      s0.parentNode.insertBefore(s1, s0);
    })();
  }

  render() {
    return <div></div>; 
  }
}

export default ChatWidget;
